<template>
    <a
        @click="handleClick"
        v-bind:target="link.has ? link.target : undefined"
        v-bind:href="link.has ? link.url : undefined"
        :data-uuid="settings.uuid"
        :style="linkStyle"
        :class="{ overlayed: overlay.overlayed }"
    >
        <img
            :width="general.width.value"
            :height="general.height.value"
            :style="imageStyle"
            :src="settings.general.src"
            :alt="settings.general.alt"
            class="widget-image"
        />
        <component v-if="overlay.enable" is="style">
            {{ overlayStyle }}
        </component>
    </a>
</template>

<script>
import { allEvents, noneEvents, resolveMargin } from "../utils/style"
import ViewMixin from "../utils/view-mixin"

export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetImage",
    mixins: [ViewMixin],
    computed: {
        desktop() {
            return this.settings.desktop
        },
        mobile() {
            return this.settings.mobile
        },
        general() {
            return this.settings.general
        },
        link() {
            return this.settings.link
        },
        overlay() {
            return this.settings.overlay
        },
        imageStyle() {
            const { stretched, radius } = this.general
            const style = {
                ...noneEvents(),
                borderRadius: `${radius.value}${radius.type}`,
                maxWidth: "100%"
            }
            if (stretched) {
                style.height = "auto"
            }
            return style
        },
        linkStyle() {
            return {
                display: "block",
                textAlign: "center",
                ...allEvents(),
                ...this.resolveStyle(
                    {
                        ...resolveMargin(this.desktop.margin)
                    },
                    {
                        ...resolveMargin(this.mobile.margin)
                    }
                )
            }
        },
        overlayStyle() {
            return `
                a[data-uuid='${this.settings.uuid}'] {
                    position: relative;
                    cursor: pointer;
                    border-radius: ${this.general.radius.value}${this.general.radius.type};
                }
                a[data-uuid='${this.settings.uuid}']:hover::after, a[data-uuid='${this.settings.uuid}'].overlayed::after {
                    height: 100%
                }
                a[data-uuid='${this.settings.uuid}']::after {
                    content: '${this.overlay.text}';
                    transition: .2s;
                    width: 100%;
                    height: 0;
                    position: absolute;
                    display:flex;
                    align-items: center;
                    justify-content: center;
                    background: ${this.overlay.background};
                    color: ${this.overlay.color};
                    border-radius: ${this.general.radius.value}${this.general.radius.type};
                    left: 0;
                    right: 0;
                    overflow: hidden;
                    text-align: center;
                    line-height: 130%;
                    bottom: 0;
                }
            `
        }
    },
    methods: {
        handleClick(event) {
            if (!this.link.has) {
                event.preventDefault()
            }
        }
    }
}
</script>

<style scoped>

</style>
